import { Grid, Typography } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';

import { useMsal } from '@azure/msal-react';
import { AmplitudeEventType } from '../../../../../analytics/amplitudeEvents';
import { BrandProps, ClientConfig } from '../../../../../clientConfig';
import { LocationState } from '../../../../../types/reactTypes';
import { ClientConfigContext } from '../../../../clientConfigContext';
import { buildIdVerificationEventProps, sendEvent } from '../../../../services/amplitudeClient';
import getAccessToken from '../../../../util/getAccessToken';
import BrandedCard from '../../../containers/BrandedCard/BrandedCard';
import { Button } from '../../../elements/Button';
import withLogger, { ComponentLoggerProps } from '../../../HOC/WithLogger';

function CollectDemographicsIntro({ brandInfo, log }: BrandProps & ComponentLoggerProps) {
    const { t } = useTranslation();
    const location = useLocation<LocationState>();
    const [phoneNumber, setPhoneNumber] = useState('');
    const [proveBypass, setProveBypass] = useState('');
    const { instance, accounts } = useMsal();
    const clientConfiguration = useContext<ClientConfig>(ClientConfigContext);
    const history = useHistory();
    const onEnteringInformation = () => {
        history.push('/demographics', {
            phoneNumber: phoneNumber,
            proveBypass: proveBypass,
            isCrossRegion: location?.state?.isCrossRegion,
        });
    };

    useEffect(() => {
        getAccessToken(instance, accounts, clientConfiguration.b2cTenantConfig.scopes, log).then((jwt) => {
            const eventProps = buildIdVerificationEventProps(AmplitudeEventType.IdentityVerification_NumberVerified, 'sms');
            sendEvent(eventProps, jwt);
        });
    }, []);
    useEffect(() => {
        setPhoneNumber(location?.state?.phoneNumber);
        setProveBypass(location?.state?.proveBypass);
    }, [location]);

    return (
        <>
            <BrandedCard brand={brandInfo}>
                {{
                    header: (
                        <>
                            <Typography variant='h2'>{t('Your phone number was verified')}</Typography>
                        </>
                    ),
                    content: (
                        <>
                            <Grid container justify='center' item xs={10} className='txtAlignCenter'>
                                <Typography variant='h3'>{t('We need to collect demographics information about you.')}</Typography>
                            </Grid>
                        </>
                    ),
                    actions: (
                        <>
                            <Grid container justify='center' item xs={12}>
                                <Grid container justify='center' item xs={10}>
                                    <Button type='button' variant='contained' onClick={onEnteringInformation}>
                                        {t('Enter My Information')}
                                    </Button>
                                </Grid>
                            </Grid>
                        </>
                    ),
                }}
            </BrandedCard>
        </>
    );
}

export default withLogger(CollectDemographicsIntro, { eventSource: 'CollectPhoneNumberForm' });
